import React, { useState, useEffect } from 'react';

function DarkModeBtn() {
   // Inicializar estado desde localStorage
   const [isActive, setIsActive] = useState(() => {
      return localStorage.getItem('pptLightMode') === 'true';
   });

   // Efecto para sincronizar el body con el estado
   useEffect(() => {
      if (isActive) {
         document.body.setAttribute('data-lightmode', 'true');
         localStorage.setItem('pptLightMode', 'true');
      } else {
         document.body.removeAttribute('data-lightmode');
         localStorage.removeItem('pptLightMode');
      }
   }, [isActive]);

   const handleClick = () => {
      setIsActive(!isActive);
   };

   return (
      <span
         className={`ppt_darkmode ${isActive ? 'active' : ''}`}
         onClick={handleClick}
      ></span>
   );
}

export default DarkModeBtn;